var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"hour-forecast"},[_c('div',{staticClass:"hour-forecast-wrap"},[_c('div',{ref:"hourForecastList",staticClass:"hour-forecast-list"},[_c('div',{attrs:{"id":"refined-rainfall"}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }